import { SectionDetails } from '@/app/types/marketing/SectionDetails';
import GeneratorLandingPage from '@/components/generator-landing-page/GeneratorLandingPage';
import {
  ClockIcon,
  ListBulletIcon,
  CircleStackIcon,
  ClipboardDocumentListIcon,
  DocumentDuplicateIcon,
  TableCellsIcon
} from '@heroicons/react/24/solid';
import overviewImage from '@/public/pptx-landing-image.png';

const imageSection: SectionDetails = {
  miniText: 'Smarter studying',
  title: 'Get instant flashcards',
  image: overviewImage,
  description:
    'Limbiks takes away the burden of creating flashcards so you can start studying immediately.',
  features: [
    {
      name: 'Configurable flashcard formats.',
      description:
        'Limbiks can generate question and answer, fill in the blank, and image occlusion flashcards. Choose the type that works best for you.',
      icon: TableCellsIcon
    },
    {
      name: 'Include notes section.',
      description:
        'Not only can Limbiks generate flashcards from your slide content, but you can also include the notes section in your flashcards.',
      icon: CircleStackIcon
    },
    {
      name: 'Choose slides.',
      description:
        'Generate from every slide or enter the specific slides you want to be used for your flashcards.',
      icon: DocumentDuplicateIcon
    }
  ]
};

const featureSection: SectionDetails = {
  miniText: 'Advanced learning',
  title: 'Suite of AI study tools',
  description:
    'Limbiks offers a wide variety of study tools so you can master your flashcards.  Our tools are custom built with all of the latest AI advancements to ensure you are getting the best possible study experience.  ',
  features: [
    {
      name: 'Multiple choice questions',
      description:
        'Study every flashcard as a multiple choice question.  Whether you use our quiz tool or take a full practice test, multiple choice questions are a perfect way to learn all of your material.',
      icon: ListBulletIcon
    },
    {
      name: 'Spaced repetition',
      description:
        'Let Limbiks manage your study schedule for you.  Use spaced repition to keep track of due dates for every flashcard. Provide ratings for each card to ensure the perfect schedule.',
      icon: ClockIcon
    },
    {
      name: 'AI Study Guides',
      description:
        'Generate study guides with every upload.  Limbiks uses AI to analyze your content and build a focused study guide of everything you need to know. All study guides can be downloaded and printed.',
      icon: ClipboardDocumentListIcon
    }
  ]
};

export default function _PdfToFlashcards() {
  return (
    <GeneratorLandingPage
      imageSection={imageSection}
      featureSection={featureSection}
      title="PowerPoint to Flashcards"
      description="Upload any PowerPoint and generate a comprehensive deck of flashcards in seconds. Download flashcards or use our AI study tools for an optimized learning experience."
    />
  );
}
